export enum EServiceAreaType {
  City = 1,
  Region = 2,
  FederalDistrict = 3,
}
